import React from 'react'
import "./Stylebutton.css"
import { Button } from '@mui/joy'
const Stylebutton = ({click, buttonText, width}) => {
  return (
    <Button onClick={() => {
      if (typeof click === "function"){
        click();
      }
    }} sx={{backgroundColor: "#2a3042"}}>{buttonText}</Button>
  )
}

export default Stylebutton
